<template>
    <v-row>
        <v-col cols="4">
            <v-list>
                <v-list-item v-for="(c, i) in callbacks" :key="i" @click="c.callback">
                    <v-list-item-icon>
                        <v-fa-icon icon="space-shuttle" />
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="c.name"></v-list-item-title>
                        <!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-col>
        <v-col>
            <pre>{{ outputData }}</pre>
        </v-col>
    </v-row>
</template>

<script>
import axios from "axios";
import { mapMutations, mapActions } from "vuex";
import * as me from "@/store/modules/AlertModule/mutations";
import * as aDevices from "@/store/modules/DevicesModule/actions";

export default {
    name: "DebugCallback",
    data() {
        return {
            outputData: {},
            callbacks: [
                {
                    name: "Show Modal Dialog",
                    callback: () => {
                        this.$modal.show("dialog", {
                            text: "You are too awesome",
                            buttons: [
                                {
                                    title: "Default", // Button title
                                    default: true, // Will be triggered by default if 'Enter' pressed.
                                    handler: () => {
                                        console.log("hello");
                                    }, // Button click handler
                                },
                                {
                                    title: "Close",
                                },
                            ],
                        });
                    },
                },
                {
                    name: "Test get api/device/folder_tree",
                    callback: async () => {
                        const res = await axios.get("api/device/folder_tree");
                        console.log("res", res);
                        this.outputData = res.data;
                    },
                },
                {
                    name: "Test get api/device/device_tree/root",
                    callback: async () => {
                        const res = await axios.get("api/device/device_tree/root");
                        console.log("res", res);
                        this.outputData = res.data;
                    },
                },
                {
                    name: "Test post api/device_status",
                    callback: async () => {
                        const res = await axios.post("api/device_status", {
                            DevicesFilter: [],
                        });
                        console.log("res", res);
                        this.outputData = res.data;
                    },
                },
                {
                    name: "Fetch all device tree",
                    callback: () => {
                        console.log("All device tree started");
                    },
                },
                // {
                //   name: "Add test error",
                //   callback: () => {
                //     console.log("me.ADD_ALERT", me.ADD_ALERT);
                //     this[me.ADD_ALERT]({
                //       type: "error",
                //       message: "Mock error created from debug" + new Date(),
                //       callback: {
                //         text: "common.retry",
                //         action: () => {
                //           console.log("retry clicked");
                //         }
                //       }
                //     });
                //   }
                // }
            ],
        };
    },
    methods: {
        ...mapMutations([me.ADD_ALERT]),
    },
};
</script>

<style scoped></style>
